import { FC, memo } from 'react'
import HeadhuntServiceWrapper from '../../../wrapper/employer/HeadhuntService'
import initPageLocale from '../../../utillities/initPageLocale'
import localeResources from './headhunt-service.locale'
import { EliminateQueryCanonical } from '../../../wrapper/jobs/SEOMeta/CanonicalMeta'
import { useTranslation } from '../../../hooks/useTranslation'
import PublicPageMeta, { THUMBNAIL_COMPANY_LP_HH } from '../../../components/seo/PublicPageMeta'
import { LINK_URL_LP_HEADHUNT_SERVICE } from '../../../utillities/LinkURL'
import withLayoutEmployer from '../../../hoc/withLayoutEmployer'
import { useUTMCollector } from '../../../modules/utm/UseCollector'
import { createSimpleEmitter } from '../../../utillities/Emitter'
import env from 'src/@legacy/utilities/env'
import style from './style.module.scss'
import LogoTags from './schema/LogoTags'
import LocalBussinessTags from './schema/LocalBusinessTags'
import FAQTags from './schema/FAQTags'
import BreadcrumbTags from './schema/BreadcrumbTags'

const refTemp = { ref: null, resolve: null }
const setRef = (ref) => {
  refTemp.ref = ref
  refTemp.resolve && refTemp.resolve(ref)
}
const getRef = () => refTemp.ref
const getRefPromise = () =>
  new Promise((resolve) => {
    if (getRef()) {
      resolve(getRef())
    }
    refTemp.resolve = resolve
  })

const refTempMobile = { ref: null, resolve: null }
const setRefMobile = (ref) => {
  refTempMobile.ref = ref
  refTempMobile.resolve && refTempMobile.resolve(ref)
}
const getRefMobile = () => refTempMobile.ref
const getRefPromiseMobile = () =>
  new Promise((resolve) => {
    if (getRefMobile()) {
      resolve(getRefMobile())
    }
    refTempMobile.resolve = resolve
  })
export const {
  emitAll: scrollEmitter,
  regiterCallback: registerClickOnContactButton,
  unregisterCallBack: unregisterClickOnContactButton
} = createSimpleEmitter()

const HeadhuntService: FC = () => {
  const { translate } = useTranslation()
  useUTMCollector()
  return (
    <div>
      <EliminateQueryCanonical rootDomain={env.PUBLIC_EMPLOYER_APP_DOMAIN} />
      <BreadcrumbTags />
      <LogoTags />
      <LocalBussinessTags />
      <FAQTags />
      <PublicPageMeta
        title={translate('page_employer_headhunt_service:lp_title')}
        description={translate('page_employer_headhunt_service:lp_description')}
        keywords={translate('page_employer_headhunt_service:lp_meta_keywords')}
        image={`${env.PUBLIC_EMPLOYER_APP_DOMAIN}${THUMBNAIL_COMPANY_LP_HH}`}
        url={`${env.PUBLIC_EMPLOYER_APP_DOMAIN}${LINK_URL_LP_HEADHUNT_SERVICE}`}
      />

      <HeadhuntServiceWrapper
        setRef={setRef}
        getRefPromise={getRefPromise}
        setRefMobile={setRefMobile}
        getRefPromiseMobile={getRefPromiseMobile}
      />
    </div>
  )
}

export default memo(
  initPageLocale(
    //@ts-ignore
    withLayoutEmployer(
      HeadhuntService,
      style.root,
      {
        scrollEmitter
      },
      true
    ),
    localeResources
  )
)
